import { unwrapResult } from '@reduxjs/toolkit';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Text, Modal, Button } from '@rsos/components/capstone/base';
import {
  ModalBody,
  ModalHeader,
} from '@rsos/components/capstone/base/Modal/ModalComponents';
import {
  updateAgency,
  setAgencyLinks,
} from '@rsos/reduxDataStore/src/features/alertsRouting/alertsRoutingSlice';
import { notifyError } from '@rsos/utils/toastUtils';
import {
  alertTypeFormatter,
  DECLINED,
  ACCEPTED,
  INBOUND,
} from '../../Common/utils';
import {
  RequestsContainer,
  RequestContainer,
} from './ViewRequestsModal.styles.js';
import ViewRequestsModalEmptyState from './ViewRequestsModalEmptyState';

const ViewRequestsModal = ({ isOpened, onClose, requests }) => {
  const dispatch = useDispatch();
  const { sinatra } = useSelector(state => state);
  const org = sinatra.user.currentOrg.name;

  const handleRequestAction = (request, status) => {
    const data = {
      org,
      id: request.id,
      status: status,
    };
    dispatch(updateAgency(data))
      .then(unwrapResult)
      .then(response => {
        if (response) dispatch(setAgencyLinks({ ...data, type: INBOUND }));
      })
      .catch(error => {
        notifyError(error);
      });
  };
  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      width={400}
      id="view-requests-modal"
      disableBackdropClick
    >
      <>
        <ModalHeader onClose={onClose}>
          <Box width={400}>
            <Text size="xlarge" color="primaryText">
              Agency pair requests
            </Text>
          </Box>
        </ModalHeader>

        <ModalBody>
          <Text size="normal" color="secondaryLink">
            These agencies would like to share their digital alerts with your
            ECC.
          </Text>
          <RequestsContainer>
            {requests.length ? (
              requests.map(r => (
                <RequestContainer>
                  <Text size="normal" color="primaryText">
                    {r.link_from.display_name}
                  </Text>
                  <Text size="normal" color="secondaryText">
                    {r.attributes.alert_emergency_types
                      .map(link => alertTypeFormatter(link))
                      .join(', ')}
                  </Text>
                  <Box horizontal flow={5} mt="4px">
                    <Button
                      btnType="tertiary"
                      onClick={() => handleRequestAction(r, DECLINED)}
                      noMargin
                    >
                      Decline
                    </Button>
                    <Button
                      btnType="primary"
                      onClick={() => handleRequestAction(r, ACCEPTED)}
                      noMargin
                    >
                      Accept
                    </Button>
                  </Box>
                </RequestContainer>
              ))
            ) : (
              <ViewRequestsModalEmptyState />
            )}
          </RequestsContainer>
        </ModalBody>
      </>
    </Modal>
  );
};

export default ViewRequestsModal;
